// extracted by mini-css-extract-plugin
export var card = "_qq-0";
export var content = "_qq-2";
export var details = "_qq-3";
export var icon = "_qq-1";
export var iconBlue = "_qq-5";
export var iconBrand = "_qq-4";
export var iconGrayBlue = "_qq-6";
export var iconGreen = "_qq-7";
export var iconIndigo = "_qq-8";
export var iconOrange = "_qq-9";
export var iconPurple = "_qq-a";
export var iconRed = "_qq-b";
export var iconWarning = "_qq-c";